export default [
  {
    id: 'politis',
    name: 'politis',
    config: {
      verticals: [
        // {
        //   id: 'ooh',
        //   title: 'POLITIS OOH',
        //   territories: ['Greece'],
        // },
        {
          id: 'ooh-politis',
          title: 'Ooh-Politis',
          territories: ['Greece'],
        },
      ],
      parameters: {
        default: {
          modes: ['pois'],
          charts: {
            active: false,
          },
          filters: [
            {
              kind: 'day',
              values: [
                {
                  info: '',
                  label: 'All Week',
                  value: 'All',
                },
                {
                  info: '',
                  label: 'Weekday',
                  value: 'Weekday',
                },
                {
                  info: '',
                  label: 'Weekend',
                  value: 'Weekend',
                },
              ],
              default: 'All',
            },
            {
              kind: 'hour',
              values: [
                {
                  info: '',
                  label: 'All Day',
                  value: 'All',
                },
                {
                  info: '6 AM - 12 PM',
                  label: 'Morning',
                  value: 'Morning',
                },
                {
                  info: '12 PM - 6 PM',
                  label: 'Afternoon',
                  value: 'Afternoon',
                },
                {
                  info: '6 PM - 12 AM',
                  label: 'Evening',
                  value: 'Evening',
                },
                {
                  info: '12 AM - 6 AM',
                  label: 'Night',
                  value: 'Night',
                },
              ],
              default: 'All',
            },
          ],
          variables: [
            {
              key: 'nvisitors',
              stats: [
                {
                  label: 'Average visits per visitor',
                  value: 'nvisitors_avg_visits',
                },
                {
                  label: 'Median visits per visitor',
                  value: 'nvisitors_median_visits',
                },
                {
                  label: 'Standard deviaton of the visits per visitor',
                  value: 'nvisitors_std_dev_visits',
                },
              ],
              targets: [
                {
                  kind: 'visitor_profile',
                  title: 'Visitor profile',
                  values: [
                    {
                      help: 'Individual who resides in a certain area.',
                      info: '',
                      kind: 'visitor_profile',
                      label: 'Resident',
                      value: 'nvisitors_visitor_profile_resident',
                      short_label: '',
                      widget_type: 'standard',
                    },
                    {
                      help: 'Individual who is recurrently detected in a specific area for more than the 50 percent of working days over a particular month and he/she does not reside in that area.',
                      info: '',
                      kind: 'visitor_profile',
                      label: 'Commuter',
                      value: 'nvisitors_visitor_profile_commuter',
                      short_label: '',
                      widget_type: 'standard',
                    },
                    {
                      help: 'Individual whose place of residence is the area and who is detected recurrently in the area.',
                      info: '',
                      kind: 'visitor_profile',
                      label: 'Local',
                      value: 'nvisitors_visitor_profile_local',
                      short_label: '',
                      widget_type: 'standard',
                    },
                    {
                      help: 'Individual whose place of residence is another place in the region and who is detected recurrently in the city',
                      info: '',
                      kind: 'visitor_profile',
                      label: 'Regional',
                      value: 'nvisitors_visitor_profile_regional',
                      short_label: '',
                      widget_type: 'standard',
                    },
                    {
                      help: 'Individual whose place of residence is not the specific area but another area in Greece and who is detected sporadically in the area',
                      info: '',
                      kind: 'visitor_profile',
                      label: 'National',
                      value: 'nvisitors_visitor_profile_national',
                      short_label: '',
                      widget_type: 'standard',
                    },
                    {
                      help: 'Individual whose place of residence is not Greece but another country and who is detected sporadically in the area.',
                      info: '',
                      kind: 'visitor_profile',
                      label: 'International',
                      value: 'nvisitors_visitor_profile_international',
                      short_label: '',
                      widget_type: 'standard',
                    },
                    {
                      help: 'Individual whose place of residence is unknown or intentionally hidden.',
                      info: '',
                      kind: 'visitor_profile',
                      label: 'NA due to GDPR',
                      value: 'nvisitors_visitor_profile_unknown',
                      short_label: '',
                      widget_type: 'standard',
                    },
                  ],
                  default: 'nvisitors_visitor_profile_resident',
                  widget_type: 'standard',
                },
                {
                  kind: 'gender',
                  title: 'Gender',
                  values: [
                    {
                      help: '',
                      info: '',
                      kind: 'gender',
                      label: 'Woman',
                      value: 'nvisitors_gender_f',
                      short_label: '',
                      widget_type: 'standard',
                    },
                    {
                      help: '',
                      info: '',
                      kind: 'gender',
                      label: 'Man',
                      value: 'nvisitors_gender_m',
                      short_label: '',
                      widget_type: 'standard',
                    },
                  ],
                  default: 'nvisitors_gender_m',
                  widget_type: 'standard',
                },
                {
                  kind: 'age',
                  title: 'Age',
                  values: [
                    {
                      help: '',
                      info: '',
                      kind: 'age',
                      label: 'Between 18 and 24',
                      value: 'nvisitors_age_18_24',
                      short_label: '18 - 24',
                      widget_type: 'standard',
                    },
                    {
                      help: '',
                      info: '',
                      kind: 'age',
                      label: 'Between 25 and 34',
                      value: 'nvisitors_age_25_34',
                      short_label: '25 - 34',
                      widget_type: 'standard',
                    },
                    {
                      help: '',
                      info: '',
                      kind: 'age',
                      label: 'Between 35 and 44',
                      value: 'nvisitors_age_35_44',
                      short_label: '35 - 44',
                      widget_type: 'standard',
                    },
                    {
                      help: '',
                      info: '',
                      kind: 'age',
                      label: 'Between 45 and 54',
                      value: 'nvisitors_age_45_54',
                      short_label: '45 - 54',
                      widget_type: 'standard',
                    },
                    {
                      help: '',
                      info: '',
                      kind: 'age',
                      label: 'Between 55 and 64',
                      value: 'nvisitors_age_55_64',
                      short_label: '55 - 64',
                      widget_type: 'standard',
                    },
                    {
                      help: '',
                      info: '',
                      kind: 'age',
                      label: 'Between 65 and 100',
                      value: 'nvisitors_age_65_100',
                      short_label: '65 - 100',
                      widget_type: 'standard',
                    },
                  ],
                  default: 'nvisitors_age_18_24',
                  widget_type: 'standard',
                },
              ],
            },
          ],
          aggregates: {
            origin: [
              {
                label: 'City',
                value: 'nvisitors_city',
              },
              {
                label: 'Municipalities',
                value: 'nvisitors_municipality',
              },
              {
                label: 'Provinces',
                value: 'nvisitors_province',
              },
              {
                label: 'Other countries',
                value: 'nvisitors_country',
              },
            ],
            destination: true,
          },
          comparison: {
            active: false,
          },
          autoinsights: {
            alls: true,
            active: false,
          },
          hasTrafficData: true,
          hasAllPOIsInPOIMap: false,
          hasCampaignCreation: true,
          mobility_map_terrunits: [
            'municipalities',
            'provinces',
            'countries',
            'grid',
          ],
        },
        ooh_week: {
          '@extends': 'default',
          '@replaces': {
            'filters.1.values.1.info': '06:00 - 12:00',
            'filters.1.values.2.info': '12:00 - 18:00',
            'filters.1.values.3.info': '18:00 - 00:00',
            'filters.1.values.4.info': '00:00 - 06:00',
          },
          'variables.0.targets.3': {
            kind: '',
            title: '',
            values: [],
            default: 'nvisitors_gender_m',
            widget_type: 'standard',
          },
        },
      },
    },
    org_id: 'politis',
    terrunit_region_id: 'GR',
  },
]
